import React, { useContext, useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { fetch_orders, fetch_sub_orders, get_order_details, get_user_details, sub_order_update } from '../api/api';
import { Link, useLocation } from 'react-router-dom';
import { MyContext } from '../context/Context';
import Pre_Loader from '../Loader/Pre_Loader';
import Loader from '../Loader/Loader';
import { DatePicker, Space } from 'antd';
import moment from 'moment';
import { toast } from 'react-toastify';
import DateRange from '../components/DateRange';
const { RangePicker } = DatePicker;


function DeliveryPartner() {
    const today = new Date().toISOString().split('T')[0]

    const { loader, setLoader, dateFormate, adminData } = useContext(MyContext);
    const [subOrderList, setSubOrderList] = useState([]);
    const location = useLocation();
    const orderId = location.state?.orderId;
    const add_close_Ref = useRef(null);
    const [markComplete, setMarkComplete] = useState(false)


    const [asignOrderValue, setAsignOrderValue] = useState({
        sub_order_id: '',
        status: "",
    });
    const [userList, setUserList] = useState([]);
    const [orderDetails, setOrderDetails] = useState({ order_no: '' });

    const [statusFilter, setStatusFilter] = useState('pending');
    const [dateFilter, setDateFilter] = useState({
        start_date: today,
        end_date: today
    })
    const [isFiltered, setIsFiltered] = useState(true);

    useEffect(() => {
        fetch_sub_orders_api(dateFilter.start_date, dateFilter.end_date);
        fetch_user_list();
    }, [statusFilter])

    const fetch_sub_orders_api = async (startDate, endDate) => {
        const filter = {};
        if (startDate && endDate) {
            filter.start_date = startDate;
            filter.end_date = endDate;
        }
        filter.order_id = orderId ? orderId : '';
        filter.status = statusFilter ? statusFilter : '';

        try {
            const res = await fetch_sub_orders(filter);
            if (res.status === 200) {
                setSubOrderList(res.data.data);
            }
        } catch (error) {
            console.error("Order List Api error:", error);
        }
    };


    const fetch_user_list = async () => {
        try {
            const res = await get_user_details({ user_type: 'delivery_boy' })
            setUserList(res.data.data);
        } catch (error) {
            console.error("User List Api error:", error);
        }
    }


    const handleFilter = (dates, dateStrings) => {
        if (dateStrings[0] && dateStrings[1]) {
            // If both dates are selected, apply filter
            setDateFilter({
                start_date: moment(dateStrings[0]).format('YYYY-MM-DD'),
                end_date: moment(dateStrings[1]).format('YYYY-MM-DD'),
            });
        } else {
            // If no dates are selected, reset filter
            setDateFilter({ start_date: '', end_date: '' });
            if (isFiltered) {
                fetch_sub_orders_api('', '')
                setIsFiltered(false);
            }
        }
    };
    const onFocus = () => {
        if (dateFilter.start_date !== '' && dateFilter.end_date !== '') {
            setDateFilter({ start_date: '', end_date: '' });  // Reset state when focus happens
        }
    }


    const applyFilter = () => {
        if (dateFilter.start_date !== '' && dateFilter.end_date !== '') {
            setIsFiltered(true);
            fetch_sub_orders_api(dateFilter.start_date, dateFilter.end_date);
        }
    }


    const asign_order = (order) => {
        setAsignOrderValue({ ...asignOrderValue, sub_order_id: order.sub_order_id, status: order.status })
        setOrderDetails(order);
    }

    const handleOnChange = (e) => {
        setAsignOrderValue({ ...asignOrderValue, [e.target.name]: e.target.value })
    }

    const saveChanges = async () => {

        if (asignOrderValue.status == "") {
            toast.error("Please select status")
            return;
        }

        console.log(asignOrderValue)

        const obj = {}

        // obj.status = markComplete ? 'delivered' : '';
        obj.user_id = adminData?.id ? adminData.id : ''

        const data = { ...asignOrderValue, ...obj, }

        try {
            const res = await sub_order_update(data)
            if (res.data.status == 200) {
                add_close_Ref.current.click();
                fetch_sub_orders_api(dateFilter.start_date, dateFilter.end_date);
                toast.success("Order Status Updated Scuccessfully")
            }

        } catch (error) {
            console.error("Asign Order Api error:", error);
        }
    }

    console.log(subOrderList)

    return (
        <div className="wrapper">
            <Navbar />

            <div className="mx-3">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex justify-content-between">
                                <h1 className="m-0">My Orders</h1>
                            </div>
                        </div>
                    </div>
                </div>


                {
                    loader ? <Loader /> : (

                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">Order List</h3>
                                            </div>
                                            <div className="card-body">
                                                <div className='mb-3 d-flex align-md-items-center flex-md-row flex-column  gap'>
                                                    <div className='d-flex align-items-center flex-wrap gap'>
                                                        <div className=''>Date :</div>
                                                        <div className=''>
                                                            {/* <Space direction="vertical" size={12}>
                                                                <RangePicker
                                                                    onChange={handleFilter}
                                                                    onFocus={() => {
                                                                        if (dateFilter.start_date !== '' && dateFilter.end_date !== '') {
                                                                            setDateFilter({ start_date: '', end_date: '' });  // Reset state when focus happens
                                                                        }
                                                                    }}
                                                                    size="large"
                                                                    value={[
                                                                        dateFilter.start_date ? moment(dateFilter.start_date) : '',
                                                                        dateFilter.end_date ? moment(dateFilter.end_date) : '',
                                                                    ]}
                                                                    onKeyDown={(e) => {
                                                                        const allowedKeys = [
                                                                            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', '-', // Control and navigation keys
                                                                        ];
                                                                        const isNumberKey = e.key >= '0' && e.key <= '9';
                                                                        const isAllowedKey = allowedKeys.includes(e.key);

                                                                        if (!isNumberKey && !isAllowedKey) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                />
                                                            </Space> */}


                                                            <DateRange handleFilter={handleFilter} onFocus={onFocus} value={[
                                                                dateFilter.start_date ? moment(dateFilter.start_date) : '',
                                                                dateFilter.end_date ? moment(dateFilter.end_date) : '',
                                                            ]} />



                                                        </div>
                                                        <div className='mr-4'>
                                                            <button
                                                                type="button"
                                                                className="btn btn-naariyal-green"
                                                                onClick={applyFilter}
                                                            >
                                                                Filter
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className='mr-4 d-flex align-items-center'>
                                                        <div className='mr-2'>
                                                            Status :
                                                        </div>
                                                        <div >
                                                            <select
                                                                className="custom-select"
                                                                name="status"
                                                                onChange={(e) => setStatusFilter(e.target.value)}
                                                                value={statusFilter}
                                                            >
                                                                <option value="">All</option>
                                                                <option value="pending">Pending</option>
                                                                <option value="out_for_delivery">Out For Delivery</option>
                                                                <option value="delivered">Delivered</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="table-responsive">
                                                    <table id="example2" className="table table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>Order No</th>
                                                                <th>Date</th>
                                                                <th>Status</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                subOrderList.length > 0 ?
                                                                    subOrderList.map((subOrder, index) => (
                                                                        <tr key={index}>
                                                                            <td>{subOrder.order_no}</td>
                                                                            <td>{dateFormate(subOrder.sub_order_date)}</td>
                                                                            {/* <td> {subOrder.status}</td> */}
                                                                            <td>
                                                                                {/* <a href="#" className={`badge badge-${subOrder.status}`}>{subOrder.status}</a> */}
                                                                                {(() => {
                                                                                    if (subOrder.status === "pending") {
                                                                                        return <span className="badge badge-warning text-sm">Pending</span>;
                                                                                    } else if (subOrder.status === "out_for_delivery") {
                                                                                        return <span className="badge badge-secondary text-sm">Out For Delivery</span>;
                                                                                    } else if (subOrder.status === "delivered") {
                                                                                        return <span className="badge badge-success text-sm">Delivered</span>;
                                                                                    }
                                                                                })()}
                                                                            </td>
                                                                            <td className='d-flex align-item-center flex-md-row flex-column gap'>
                                                                                <div className='mr-3'>
                                                                                    <button
                                                                                        className='btn btn-warning text-nowrap'
                                                                                        data-toggle="modal"
                                                                                        data-backdrop="static"
                                                                                        data-target="#asignOrder"
                                                                                        onClick={() => asign_order(subOrder)}
                                                                                    >
                                                                                        <i className="nav-icon fa-solid fa-list-check mr-2"></i>
                                                                                        Manage Order
                                                                                    </button>
                                                                                </div>
                                                                                <div>
                                                                                    <button className='btn btn-info text-nowrap'
                                                                                        onClick={() => {
                                                                                            let text = subOrder.delivery_address
                                                                                            let result = text.length - 7
                                                                                            let address = text.slice(0, result)
                                                                                            console.log(address)
                                                                                            
                                                                                            window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`, '_blank')
                                                                                        }}>
                                                                                        <i className="nav-icon fa-solid fa-map-location-dot mr-2"></i>
                                                                                        Locate on Map
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                    : <tr>
                                                                        <td colSpan={7}>
                                                                            <span>
                                                                                No data available
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Complete Order Model */}
                            <div className="modal fade" id="asignOrder" tabIndex={-1} role="dialog" aria-labelledby="orderDetailsModal" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header border-0">
                                            <h5>Order Details</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                                onClick={() => setAsignOrderValue({ ...asignOrderValue, user_id: '' })}
                                                ref={add_close_Ref}>
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="input-group">
                                                <div className='w-100 mb-3 d-flex'>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Mobile No</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='customer_name'
                                                            value={orderDetails.mobile_no}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div >
                                                        <label htmlFor="area_name">Customer Name</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='customer_name'
                                                            value={orderDetails?.customer_firstname + " " + orderDetails?.customer_lastname}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-100 mb-3'>
                                                    <label htmlFor="area_name">Delivery Address</label>
                                                    <textarea
                                                        type=""
                                                        style={{ fontSize: "14px" }}
                                                        rows={4}
                                                        className="form-control"
                                                        name='delivery_address'

                                                        value={orderDetails.delivery_address}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='w-100 mb-3 d-flex'>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Order No</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='delivery_address'
                                                            value={orderDetails.order_no}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className=''>
                                                        <label htmlFor="area_name">Date</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='delivery_address'
                                                            value={dateFormate(orderDetails.sub_order_date)}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-100'>
                                                    <label htmlFor="area_name">Delivery Status</label>
                                                    <select
                                                        className="custom-select"
                                                        name="status"
                                                        value={asignOrderValue.status}
                                                        onChange={handleOnChange}
                                                        disabled={orderDetails.status == 'delivered' ? true : false}

                                                    >
                                                        <option value="">Select Status...</option>
                                                        <option value="pending">Pending</option>
                                                        <option value="out_for_delivery">Out For Delivery</option>
                                                        <option value="delivered">Delivered</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer border-0">
                                            {orderDetails.status == 'delivered'
                                                ? <div className='text-center m-auto text-success'>
                                                    <i class="nav-icon fa-solid fa-check mr-2"></i>Order Completed</div>
                                                : (<button
                                                    type="button"
                                                    className="btn btn-naariyal-green m-auto"
                                                    onClick={saveChanges}
                                                >
                                                    Save details
                                                </button>)

                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>


                        </section>

                    )
                }
            </div>

            <Footer />
            <aside className="control-sidebar control-sidebar-dark"></aside>
        </div>
    );
}

export default DeliveryPartner;
